import { CardWrapper, Icon } from '@design-system';
import Link from 'next/link';
import { FC } from 'react';

interface Props {
  href?: string;
  footerIcon?: 'location';
  footerText?: string;
  onClick?: (href: string, title?: string) => void;
  target?: 'self' | '_blank';
  title?: string;
}

export const LinkCard: FC<Props> = ({
  footerIcon,
  footerText,
  href,
  onClick,
  target = 'self',
  title,
}) => {
  const card = (
    <CardWrapper variant="tertiary">
      <div className="flex aspect-[4/3] w-full flex-col items-start justify-between gap-3 p-6 transition duration-300 ease-out group-hover:text-neutral-4">
        <h3 className="text-pretty font-bold">{title}</h3>

        <span className="flex items-center gap-1 text-neutral-4">
          {footerIcon === 'location' && (
            <span className="shrink-0">
              <Icon name="ic_location" />
            </span>
          )}
          <span className="truncate">{footerText}</span>
        </span>
      </div>
    </CardWrapper>
  );

  if (href) {
    return (
      <Link
        className="group"
        href={href}
        onClick={() => onClick?.(href, title)}
        target={target}
      >
        {card}
      </Link>
    );
  }

  return card;
};
